import {writable} from "svelte/store";
import {eventBus} from "./event-bus-store.js";

const allClosed = {
    sectionsOpened: false,
    filtersOpened: false,
    searchPanelOpened: false,
    cartOpened: false,
    detailsOpened: false,
    orderFormOpened: false,
    orderPlacementResultOpened: false,
};

/**
 * {
 *  detailsRecord: null,
 *  detailsOpened: boolean,
 *  filtersOpened: boolean,
 *  sectionsOpened: boolean,
 *  cartOpened: boolean
 * }
 *
 * @type {Writable<{detailsRecord: null, detailsOpened: boolean, filtersOpened: boolean, sectionsOpened: boolean, cartOpened: boolean}>}
 */
export const screensStore = writable({
    sectionsOpened: false,
    filtersOpened: false,
    searchPanelOpened: false,
    cartOpened: false,
    detailsOpened: false,
    detailsRecord: null,

    orderFormOpened: false,
    orderPlacementResultOpened: false,
});

export const toggleSectionsPanel = () => {

    screensStore.update(x => {
        x.sectionsOpened = !x.sectionsOpened;
        if (x.sectionsOpened) {
            x.searchPanelOpened = false;
            x.filtersOpened = false;
            x.cartOpened = false;
        }

        return x;
    });
}

export const toggleAllergensFilterPanel = () => {
    screensStore.update(x => {
        x.filtersOpened = !x.filtersOpened;
        if (x.filtersOpened) {
            x.searchPanelOpened = false;
            x.sectionsOpened = false;
            x.cartOpened = false;
        }
        return x;
    });
}

export const toggleSearchPanel = () => {
    screensStore.update(x => {
        x.searchPanelOpened = !x.searchPanelOpened;
        if (x.searchPanelOpened) {
            x.filtersOpened = false;
            x.sectionsOpened = false;
            x.cartOpened = false;
        }
        return x;
    });
}

export const closeAllergensFilterPanel = () => {
    screensStore.update(x => {
        x.filtersOpened = false;
        return x;
    });
}

export const toggleDetailsScreen = (record) => {
    screensStore.update(x => {

        if (x.detailsRecord !== null && x.detailsRecord !== undefined) {
            x.detailsRecord = null;
            x.detailsOpened = false;
        } else {
            x.detailsRecord = record;
            x.detailsOpened = true;

            eventBus.set([{event: 'openDetails', payload: {record}}]);
        }

        return x;
    });
}

export const openCartScreen = () => {
    screensStore.update(x => {
        return {
            ...allClosed,
            cartOpened: true
        };
    });
}

export const closeCartScreen = () => {
    screensStore.update(x => {
        x.cartOpened = false;
        return x;
    });
}

export const closeOrderItem = () => {
    screensStore.update(x => {
        x.orderItemOpened = false;
        x.orderItemData = null;
        return x;
    });
}

export const updateOrderItemData = (orderItemData) => {
    screensStore.update(x => {
        x.orderItemData = orderItemData;
        return x;
    });
}

export const openOrderScreen = () => {
    screensStore.update(x => {
        return {
            ...allClosed,
            cartOpened: true,
            orderFormOpened: true
        };
    });
};

export const closeOrderScreen = () => {
    screensStore.update(x => {
        x.orderFormOpened = false;
        x.cartOpened = true;
        return x;
    });
};

export const openOrderPlacementResultScreen = () => {
    screensStore.update(x => {
        return {
            ...allClosed,
            orderPlacementResultOpened: true
        };
    });
};

export const closeOrderPlacementResultScreen = () => {
    screensStore.update(x => {
        x.orderPlacementResultOpened = false;
        return x;
    });
};
